import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

export type ToastTipo = "success" | "error" | "warning" | "info";

export interface ToastItem {
  id: number;
  tipo: ToastTipo;
  titulo: string;
  mensagem: string;
  exibindo: boolean;
  saindo: boolean;
}

@Injectable({
  providedIn: "root",
})
export class ToastNotificationService {
  private sequencia = 0;
  private itens: ToastItem[] = [];
  private temporizadores = new Map<number, ReturnType<typeof setTimeout>>();
  readonly toasts$ = new BehaviorSubject<ToastItem[]>([]);

  success(mensagem: string, titulo = "Sucesso") {
    this.mostrar("success", mensagem, titulo);
  }

  error(mensagem: string, titulo = "Erro") {
    this.mostrar("error", mensagem, titulo);
  }

  warning(mensagem: string, titulo = "Atenção") {
    this.mostrar("warning", mensagem, titulo);
  }

  info(mensagem: string, titulo = "Informação") {
    this.mostrar("info", mensagem, titulo);
  }

  private mostrar(tipo: ToastTipo, mensagem: string, titulo: string) {
    const toast: ToastItem = {
      id: ++this.sequencia,
      tipo,
      titulo,
      mensagem,
      exibindo: false,
      saindo: false,
    };
    this.itens = [...this.itens, toast];
    this.toasts$.next(this.itens);

    setTimeout(() => {
      this.itens = this.itens.map((item) =>
        item.id === toast.id ? { ...item, exibindo: true } : item
      );
      this.toasts$.next(this.itens);
    }, 20);

    const temporizador = setTimeout(() => this.iniciarSaida(toast.id), 3000);
    this.temporizadores.set(toast.id, temporizador);
  }

  fechar(id: number) {
    const temporizador = this.temporizadores.get(id);
    if (temporizador) {
      clearTimeout(temporizador);
      this.temporizadores.delete(id);
    }
    this.iniciarSaida(id);
  }

  private iniciarSaida(id: number) {
    const atual = this.itens.find((item) => item.id === id);
    if (!atual || atual.saindo) {
      return;
    }
    this.temporizadores.delete(id);
    this.itens = this.itens.map((item) =>
      item.id === id ? { ...item, saindo: true } : item
    );
    this.toasts$.next(this.itens);
    setTimeout(() => this.remover(id), 350);
  }

  private remover(id: number) {
    this.itens = this.itens.filter((item) => item.id !== id);
    this.toasts$.next(this.itens);
  }
}
